__turbopack_context__.v({
  "ad-article-halfbanner": "PoD6GW_ad-article-halfbanner",
  "ad-article-lleaderboard": "PoD6GW_ad-article-lleaderboard",
  "button-article": "PoD6GW_button-article",
  "detail": "PoD6GW_detail",
  "header-article": "PoD6GW_header-article",
  "section": "PoD6GW_section",
});
